<script setup lang="ts">
    const { id, variant = 'primary' } = defineProps<{
        id: string;
        variant?: 'primary' | 'secondary' | 'tertiary';
    }>();

    const modelValue = defineModel<boolean>({ required: true });
</script>

<template>
    <input
        :id="id"
        v-model="modelValue"
        class="basic-checkbox"
        :class="variant"
        type="checkbox"
    />
</template>

<style scoped lang="scss">
    .basic-checkbox {
        &.primary {
            --checkbox-color: var(--brand-primary);
            --checkbox-hover: var(--brand-primary-70);
            --checkbox-hover-not-checked: var(--brand-primary-30);
        }
        &.secondary {
            --checkbox-color: var(--brand-secondary);
            --checkbox-hover: var(--brand-secondary-70);
            --checkbox-hover-not-checked: var(--brand-secondary-30);
        }
        &.tertiary {
            --checkbox-color: var(--brand-tertiary);
            --checkbox-hover: var(--brand-tertiary-70);
            --checkbox-hover-not-checked: var(--brand-tertiary-30);
        }

        min-width: var(--spacing);
        width: var(--spacing);
        height: var(--spacing);
        appearance: none;
        margin: 0;
        border-radius: var(--border-radius-xs);
        border: 1px solid var(--gray);
        border-color: var(--black);
        background-color: var(--white);
        cursor: pointer;
        transition: all 0.2s ease;
        padding: 0.75rem;

        &:checked {
            border-color: var(--checkbox-color);
            background-color: var(--checkbox-color);
            background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"%3E%3Cpath fill="%23fff" d="M6.173 12.847L2.31 9.233l1.1-1.115 2.76 2.768L12.573 3.93l1.103 1.11z"/%3E%3C/svg%3E');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 80%;
        }

        &:hover {
            background-color: var(--checkbox-hover);
        }

        &:hover:not(:checked) {
            background-color: var(--checkbox-hover-not-checked);
        }

        &:focus-visible {
            outline: 2px solid var(--color-focus);
            outline-offset: 2px;
        }
    }
</style>
